import safeStorage from './safeStorage';
import { trustedPanelHost } from './apiHost';

// The panel's Meta Pixel id, read out of the snippet the portal API still sends. The snippet itself is
// never run or inserted: only this number survives, and the cookie banner loads the pixel from it, with
// marketing consent (cookieConsent.configureMetaPixel).
export const PIXEL_ID = /^\d{5,20}$/;
const STORAGE_KEY = 'meta-pixel-id';
const INIT_CALL = /fbq\(\s*['"]init['"]\s*,\s*['"](\d{5,20})['"]/g;

// One id across the text, or null: no call, or two different ids, leaves no safe choice.
export const extractPixelId = (...texts) => {
  const ids = new Set();
  texts.forEach(text => {
    if (typeof text !== 'string') return;
    for (const match of text.matchAll(INIT_CALL)) ids.add(match[1]);
  });
  return ids.size === 1 ? [...ids][0] : null;
};

// Applied at the next boot (src/index.js). Kept with the panel host it came from: the id is only valid
// for that panel, and a member can switch panels without logging out. null or an invalid value forgets it.
export const rememberPixelId = id => {
  if (typeof id === 'string' && PIXEL_ID.test(id)) {
    safeStorage.setItem(STORAGE_KEY, JSON.stringify({ panel: trustedPanelHost(), id }));
  } else {
    safeStorage.removeItem(STORAGE_KEY);
  }
};

// Anything but a well-formed record for the current panel (an old plain string, broken JSON, another
// panel's id) yields null.
export const storedPixelId = () => {
  try {
    const { panel, id } = JSON.parse(safeStorage.getItem(STORAGE_KEY));
    return panel === trustedPanelHost() && typeof id === 'string' && PIXEL_ID.test(id) ? id : null;
  } catch (e) {
    return null;
  }
};
